import { type MotifComponent, type MotifComponentProps, m } from '../../motif';
import { heroDarkBgVars, heroLightBgVars } from './Hero.palette';

export const snapHeroPrimaryVars: MotifComponentProps<MotifComponent.HERO> = {
  ...heroLightBgVars,
  '--hero-title-de-emphasized-color': m('--neutral-v500'),
  '--hero-text-color-curtain-active': m('--neutral-v700'),
  '--hero-content-desktop-padding': `${m('--spacing-xl')} 0px ${m('--spacing-xl')} ${m(
    '--spacing-m'
  )}`,
} as const;

export const snapHeroSecondaryVars: MotifComponentProps<MotifComponent.HERO> = {
  ...heroDarkBgVars,
  '--hero-title-de-emphasized-color': m('--neutral-v250'),
  '--hero-text-color-curtain-active': m('--neutral-v0'),
  '--hero-content-desktop-padding': `${m('--spacing-xl')} 0px ${m('--spacing-xl')} ${m(
    '--spacing-m'
  )}`,
} as const;
